import {ACTIONS} from '../actions/Actions'

const users = (state = {errors: []}, action) => { 
  switch  (action.type){
    case ACTIONS.companies.show().statuses.requested: {
	    return Object.assign({}, state, {loading: true})
    }
    case ACTIONS.companies.show().statuses.completed: {
	    return Object.assign({}, state, {loading: false})
    }
    case ACTIONS.companies.show().statuses.error: {
	    return Object.assign({}, state, {loading: false})
    }
    case ACTIONS.reports.create().statuses.error: {
	    if(action.data != null && action.data.error_code != null)
	      return Object.assign({}, state, {errors: [...state.errors, action.data.error_code]})
	    else
	      return Object.assign({}, state, {errors: [...state.errors, 'GENERIC_ERROR']})
    }
    case ACTIONS.reports.update().statuses.error: {
	    if(action.data != null && action.data.error_code != null)
	      return Object.assign({}, state, {errors: [...state.errors, action.data.error_code]})
	    else
	      return Object.assign({}, state, {errors: [...state.errors, 'GENERIC_ERROR']})
    }
    default:
	    return state
  }
}
export default users
